import { memo, useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'
import clsx from 'clsx'
import { IconButton, Collapse, Box } from '@material-ui/core'
import DescriptionRoundedIcon from '@material-ui/icons/DescriptionRounded'
import themesConfig from 'app/fuse-configs/themesConfig'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import CloseIcon from '@material-ui/icons/Close'
import { setShowProgressBar as setShowProgressBarOnSISImport } from 'app/store/importExternalSource'

import CheckCircleOutlineIcon from 'app/components/icons/CheckCircleOutlineIcon'

import useStyles, { CustomLinearProgress } from './styles'

const ProgressBar = ({
  title,
  percent,
  handleCancel,
  importInfo,
  variantLinearProgress,
  index,
  cancelImportType,
  onClickProgressBar,
  isShowCancelButton = true,
  color,
}) => {
  const dispatch = useDispatch()
  const [showProgress, setShowProgress] = useState(true)

  const classes = useStyles()

  const changeShowProgress = (e) => {
    e.stopPropagation()
    setShowProgress((prevState) => !prevState)
  }

  const handleCancelProcess = (e) => {
    e.stopPropagation()
    handleCancel(cancelImportType)
  }

  useEffect(() => {
    return () => {
      if (percent === 100) {
        dispatch(setShowProgressBarOnSISImport(false))
      }
    }
  }, [])

  return (
    <div
      className={clsx(classes.progressBar, {
        'mt-5': index,
        'cursor-pointer': onClickProgressBar,
      })}
      onClick={onClickProgressBar && onClickProgressBar}
    >
      <p className={classes.prograssTitle}>
        <FormattedMessage id={title} />
        <IconButton
          className="p-2"
          component="span"
          onClick={changeShowProgress}
        >
          {showProgress ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </p>
      <Collapse orientation="horizontal" in={showProgress}>
        <div className={classes.progressIndicatorWrap}>
          <Box display={'flex'} alignItems={'center'}>
            <Box marginRight={3} width={'100%'}>
              <Box
                display={'flex'}
                alignItems={'center'}
                flexWrap={'wrap'}
                mb={1}
              >
                <DescriptionRoundedIcon
                  style={{ color: themesConfig.default.colors.secondary }}
                />
                {importInfo}
              </Box>
              <CustomLinearProgress
                variant={variantLinearProgress}
                valueBuffer={percent}
                value={percent}
                color={color}
              />
            </Box>
            {isShowCancelButton ? (
              <Box display={'flex'} component={'span'}>
                {percent === 100 ? (
                  <CheckCircleOutlineIcon />
                ) : (
                  <IconButton
                    className="p-2"
                    component="span"
                    onClick={handleCancelProcess}
                  >
                    <CloseIcon className={classes.closeIcon} />
                  </IconButton>
                )}
              </Box>
            ) : null}
          </Box>
        </div>
      </Collapse>
    </div>
  )
}

export default memo(ProgressBar)
